import { Platform, Dimensions } from "react-native";

/**
 * Check if the current device is an iOS mobile phone (not iPad)
 * @returns true if device is iOS with width < 768px
 */
export const isIOSMobile = (): boolean => {
  const windowWidth = Dimensions.get("window").width;
  return Platform.OS === "ios" && windowWidth < 768;
};

/**
 * Check if the current device is a mobile phone (iOS or Android, not tablet)
 * @returns true if device is iOS/Android with width < 768px
 */
export const isMobilePhone = (): boolean => {
  const windowWidth = Dimensions.get("window").width;
  return (Platform.OS === "ios" || Platform.OS === "android") && windowWidth < 768;
};

/**
 * Check if the current device is a mobile device (phone or tablet)
 * @returns true if device width < 768px
 */
export const isMobileDevice = (): boolean => {
  return Dimensions.get("window").width < 768;
};
